import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'headerTitleVerticalLine'
})
export class HeaderTitleVerticalLinePipe implements PipeTransform {
	public constructor(private sanitizer: DomSanitizer) {}
	public transform(headerTitle: string) {
		return this.sanitizer.bypassSecurityTrustHtml(
			headerTitle.split('|').join('<span style="color:var(--ion-color-primary-tint)">|</span>')
		);
	}
}
